__turbopack_context__.v({
  "btn": "dWQ2Wa_btn",
  "compactBtn": "dWQ2Wa_compactBtn",
  "compactFollowing": "dWQ2Wa_compactFollowing",
  "follow": "dWQ2Wa_follow",
  "following": "dWQ2Wa_following",
});
